import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import SurveyThankYou from "./SurveyThankYou";

const ECSurveyForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState("");
  // const decodedString = atob(token);
  // console.log('Decoded String:', decodedString);
  // Display the decoded data
  const username = localStorage.getItem("userName");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [alreadySubmittedCountdown, setAlreadySubmittedCountdown] = useState(6);
  const [isInitializingSurvey, setIsInitializingSurvey] = useState(true);

  useEffect(() => {
    if (!alreadySubmitted) return;
    const interval = setInterval(() => {
      setAlreadySubmittedCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.location.href = "https://ecoprism.com/";
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [alreadySubmitted]);
  const [sitelocation, setSiteLocation] = useState("");
  const [activesitelocation, setActiveSiteLocation] = useState("");
  const [datasitelocation, setDataSiteLocation] = useState("");

  const [surveyFromDate, setSurveyFromDate] = useState("");
  const [surveyToDate, setSurveyToDate] = useState("");
  const [validFromDate, setValidFromDate] = useState("");
  const [validToDate, setValidToDate] = useState("");
  const [surveyToken, setSurveyToken] = useState("");
  const [companyId, setCompanyId] = useState("");

  const hasEmployeeSurveyBeenSubmitted = async (
    tokenValue,
    companyid,
    employeeEmailValue,
    surveyFromDateValue,
    surveyToDateValue
  ) => {
    const statusEndpoint =
      process.env.REACT_APP_EC_SURVEY_STATUS_API_URL ||
      `${process.env.REACT_APP_BASE_API_URL}check-employee-commute-survey-link-status`;

    try {
      const response = await fetch(statusEndpoint, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: tokenValue,
          companyId: companyid,
          employeeEmail: employeeEmailValue,
          surveyFromDate: surveyFromDateValue,
          surveyToDate: surveyToDateValue,
        }),
      });

      if (!response.ok) {
        return false;
      }

      const responseText = await response.text();
      let responseJson;
      try {
        responseJson = JSON.parse(responseText);
      } catch (parseError) {
        responseJson = responseText;
      }

      const normalizedResponseText = (responseText || "").toString().toLowerCase();
      const normalizedResponseJsonText =
        typeof responseJson === "string"
          ? responseJson.toLowerCase()
          : JSON.stringify(responseJson || {}).toLowerCase();

      const hasDuplicateOrSubmittedMessage =
        normalizedResponseText.includes("duplicate survey") ||
        normalizedResponseText.includes("already submitted") ||
        normalizedResponseText.includes("already filled") ||
        normalizedResponseJsonText.includes("duplicate survey") ||
        normalizedResponseJsonText.includes("already submitted") ||
        normalizedResponseJsonText.includes("already filled");

      return (
        responseJson === true ||
        responseJson === "true" ||
        responseJson?.alreadyFilled === true ||
        responseJson?.isSubmitted === true ||
        responseJson?.submitted === true ||
        responseJson?.data === true ||
        responseJson?.data === "true" ||
        responseJson?.data?.isSurveyFilled === true ||
        responseJson?.data?.IsSurveyFilled === true ||
        responseJson?.data?.alreadyFilled === true ||
        responseJson?.data?.isSubmitted === true ||
        responseJson?.data?.submitted === true ||
        responseJson?.data?.ReasonCode === "AlreadySubmitted" ||
        hasDuplicateOrSubmittedMessage
      );
    } catch (error) {
      console.error("Error checking employee survey submission status:", error);
      return false;
    }
  };

  useEffect(() => {
    const initializeSurvey = async () => {
      const queryParams = new URLSearchParams(location.search);
      const tokenFromUrl = queryParams.get("token");
      const empEmail = queryParams.get("email");
      if (tokenFromUrl) {
        if (localStorage.getItem(`ec_survey_submitted_${tokenFromUrl}`)) {
          setIsInitializingSurvey(false);
          setAlreadySubmitted(true);
          return;
        }
        console.log(tokenFromUrl);
        const decodedString = atob(tokenFromUrl);
        const [companyid, formattedFromDate, formattedToDate, formattedExpiryDate, formattedDate, username] = decodedString.split(":");
        console.log("Decoded String:", decodedString);

        const isAlreadySubmitted = await hasEmployeeSurveyBeenSubmitted(
          tokenFromUrl,
          companyid,
          empEmail,
          formattedFromDate,
          formattedToDate
        );
        if (isAlreadySubmitted) {
          localStorage.setItem(`ec_survey_submitted_${tokenFromUrl}`, 'true');
          setIsInitializingSurvey(false);
          setAlreadySubmitted(true);
          return;
        }

        const fromParts = formattedFromDate.split("-");
        const fromDate = `${fromParts[2]}-${fromParts[1]}-${fromParts[0]}`;

        const toParts = formattedToDate.split("-");
        const toDate = `${toParts[2]}-${toParts[1]}-${toParts[0]}`;
        setFormData({
          ...formData,
          surveyPeriod: fromDate + " to " + toDate,
          employeeEmail: empEmail, // Set the state based on the selected location
        });
        setSurveyFromDate(formattedFromDate);
        setSurveyToDate(formattedToDate);
        setValidFromDate(formattedFromDate);
        setValidToDate(formattedToDate);
        setSurveyToken(tokenFromUrl);
        setCompanyId(companyid);
        setToken(tokenFromUrl);
        fetchSiteLocation(username);
      }
      setIsInitializingSurvey(false);
      console.log(formData);
    };

    initializeSurvey();
  }, []);

  async function fetchSiteLocation(username) {
    var myHeaders = new Headers();
    myHeaders.append("username", username);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-sitelocation`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          setSiteLocation("");
        } else if (responseJson.status == 400) {
          setSiteLocation("");
        } else {
          setSiteLocation(responseJson);
          setActiveSiteLocation(responseJson.data.filter((item) => item.isActive === true));
          setDataSiteLocation("");
        }
      } else {
        setSiteLocation("");
      }
    } catch (error) {
      console.error(error);
    }
  }

  const [data, setData] = useState([
    { id: 1, equipment: "Lighting", usage: null, wattage: null },
    { id: 2, equipment: "Fan", usage: null, wattage: null },
    { id: 3, equipment: "PC/Laptop", usage: null, wattage: null },
    { id: 4, equipment: "Monitor", usage: null, wattage: null },
    { id: 5, equipment: "Printer", usage: null, wattage: null },
    { id: 6, equipment: "Mobile phone", usage: null, wattage: null },
    { id: 7, equipment: "Heating", usage: null, wattage: null },
    { id: 8, equipment: "Cooling", usage: null, wattage: null },
  ]);

  const handleInputChangeDataTableUsage = (e, rowData, rowIndex) => {
    const { id, value } = e.target;
    let updatedData = [...data];
    updatedData[rowIndex]["usage"] = value;
    setData(updatedData);
  };

  const handleInputChangeDataTableWattage = (e, rowData, rowIndex) => {
    const { id, value } = e.target;
    let updatedData = [...data];
    updatedData[rowIndex]["wattage"] = value;
    setData(updatedData);
  };

  const handleRowAction = (rowData, rowIndex) => {
    // For example, you can calculate some values for this row
    console.log("Action triggered for row:", rowIndex, rowData);

    // Perform custom logic here, e.g., calculating based on rowData
    let newUsage = 0; // Example logic to update usage
    let newWattage = 0; // Example logic to update wattage
    console.log(rowData);
    if (rowData.id === 1) {
      newUsage = 8;
      newWattage = 25;
    } else if (rowData.id === 2) {
      newUsage = 8;
      newWattage = 50;
    } else if (rowData.id === 3) {
      newUsage = 8;
      newWattage = 80;
    } else if (rowData.id === 4) {
      newUsage = 8;
      newWattage = 30;
    } else if (rowData.id === 5) {
      newUsage = 0.5;
      newWattage = 250;
    } else if (rowData.id === 6) {
      newUsage = 1.5;
      newWattage = 60;
    } else if (rowData.id === 7) {
      newUsage = 8;
      newWattage = 600;
    } else if (rowData.id === 8) {
      newUsage = 8;
      newWattage = 2000;
    } else {
      newUsage = 0;
      newWattage = 0;
    }

    let updatedData = [...data];
    updatedData[rowIndex] = { ...rowData, usage: newUsage, wattage: newWattage };
    console.log(updatedData);

    setData(updatedData);
  };

  const [formData, setFormData] = useState({
    employeeId: "",
    siteLocation: "",
    workingDays: "",
    wfhDays: "",
    distance: "",
  });

  const [isDistanceRequired, setIsDistanceRequired] = useState(false);
  const [isDistanceDisabled, setIsDistanceDisabled] = useState(true);

  const [errors, setErrors] = useState({});
  const [validationMessage, setValidationMessage] = useState("");

  const handleInputChange = (e, rowData, rowIndex) => {
    const { id, value } = e.target;
    let finalValue = value;
    if (id === "fuelEfficiency") {
      const digitsOnly = value.replace(/[^0-9.]/g, "");
      const parts = digitsOnly.split(".");
      finalValue = parts.length > 2 ? parts[0] + "." + parts.slice(1).join("") : digitsOnly;
    }
    setFormData({ ...formData, [id]: finalValue });
  };

  const siteLocations = activesitelocation
    ? activesitelocation.map((status) => ({
        label: status.name,
        value: status.name,
        state: status.state,
        country: status.country,
      }))
    : [];

  const workingDaysOptions = [
    { label: "1 day", value: "1" },
    { label: "2 days", value: "2" },
    { label: "3 days", value: "3" },
    { label: "4 days", value: "4" },
    { label: "5 days", value: "5" },
    { label: "6 days", value: "6" },
    { label: "7 days", value: "7" },
  ];

  // WFH days options are capped to the selected number of working days
  const allWfhDaysOptions = [
    { label: "0 day", value: "0" },
    { label: "1 day", value: "1" },
    { label: "2 days", value: "2" },
    { label: "3 days", value: "3" },
    { label: "4 days", value: "4" },
    { label: "5 days", value: "5" },
    { label: "6 days", value: "6" },
    { label: "7 days", value: "7" },
  ];
  const wfhDaysOptions = formData.workingDays
    ? allWfhDaysOptions.filter((opt) => parseInt(opt.value) <= parseInt(formData.workingDays))
    : allWfhDaysOptions;

  const transportOptions = [
    { label: "Car", value: "Car" },
    { label: "Bus", value: "Bus" },
    { label: "Bicycle", value: "Bicycle" },
    { label: "Walking", value: "Walking" },
    // Add more transport modes as needed
  ];

  const fuelOptions = [
    { label: "Petrol", value: "Petrol" },
    { label: "Diesel", value: "Diesel" },
    { label: "Electric", value: "Electric" },
    { label: "Hybrid", value: "Hybrid" },
    // Add more fuel types as needed
  ];

  const unitOptions = [
    { label: "km/l", value: "km/l" },
    { label: "miles/gallon", value: "miles/gallon" },
    // Add more units as needed
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.employeeId) newErrors.employeeId = "Employee ID is required";
    if (!formData.siteLocation) newErrors.siteLocation = "Site Location is required";
    if (!formData.workingDays) newErrors.workingDays = "No. of working days is required";
    if (formData.wfhDays === "" || formData.wfhDays === null || formData.wfhDays === undefined) {
      newErrors.wfhDays = "Please select work from office days";
    } else if (formData.workingDays && parseInt(formData.wfhDays) > parseInt(formData.workingDays)) {
      newErrors.wfhDays = "Work from office days cannot exceed working days";
    }
    if (isDistanceRequired && !formData.distance) {
      newErrors.distance = "Distance is required";
    }
    // Transport section is visible whenever wfhDays is not "0" (including empty)
    if (formData.wfhDays !== "0" && !formData.primaryTransport) {
      newErrors.primaryTransport = "Primary mode of transport is required";
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleSave = async () => {
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      // Show validation error message below the button
      setValidationMessage("One or more required fields are missing. Please complete them before submitting.");
      return;
    }

    // Clear validation message if form is valid
    setValidationMessage("");
    setLoading(true);
    const wfhh = formData.wfh;
    let wfhradio;
    if (wfhh === "true") {
      wfhradio = true;
    } else {
      wfhradio = false;
    }
    let validate = await fetch(`${process.env.REACT_APP_BASE_API_URL}validate-survey`, {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify({
        companyId: companyId,
        token: surveyToken,
        surveyFromDate: validFromDate,
        surveyToDate: validToDate,
      }),
    });

    if (validate.status === 200) {
      let responseJson;
      try {
        responseJson = await validate.json();
      } catch {
        // empty or non-JSON body — treat as passed validation, proceed to save
        responseJson = {};
      }
      if (responseJson.success === false) {
        setLoading(false);
        console.log(responseJson);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4><p style="font-size: 16px;">${responseJson.data}</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
      } else if (responseJson.status === 400) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
              <p style="font-size: 16px;">${responseJson.title}</p>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
        });
      } else {
        console.log(data);
        let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}save-survey-response`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({
            surveyFromDate: surveyFromDate,
            surveyToDate: surveyToDate,
            surveyToken: surveyToken,
            employeeId: formData.employeeId,
            employeeEmail: formData.employeeEmail,
            employeeName: formData.employeeName,
            siteLocation: formData.siteLocation,
            city: "",
            state: formData.state,
            country: formData.country,
            workingDaysInWeek: formData.workingDays !== "" && formData.workingDays != null ? parseInt(formData.workingDays, 10) : 0,
            distanceFromHomeToOfficeKm: formData.distance !== "" && formData.distance != null ? parseFloat(formData.distance) : 0,
            averageWorkFromOfficeDaysEachWeek: formData.wfhDays !== "" && formData.wfhDays != null ? parseInt(formData.wfhDays, 10) : 0,
            primaryModeOfTransport: formData.primaryTransport,
            transportType: formData.transportType,
            fuelUsedInVehicle: formData.fuelUsed,
            fuelEfficiency: formData.fuelEfficiency !== "" && formData.fuelEfficiency != null ? parseFloat(formData.fuelEfficiency) : null,
            fuelEfficiencyUnit: formData.unit,
            lightingUsagePerDay: data[0].usage,
            lightingWattage: data[0].wattage,
            fanUsagePerDay: data[1].usage,
            fanWattage: data[1].wattage,
            pcLaptopUsagePerDay: data[2].usage,
            pcLaptopWattage: data[2].wattage,
            monitorUsagePerDay: data[3].usage,
            monitorWattage: data[3].wattage,
            printerUsagePerDay: data[4].usage,
            printerWattage: data[4].wattage,
            mobilePhoneUsagePerDay: data[5].usage,
            mobilePhoneWattage: data[5].wattage,
            heatingUsagePerDay: data[6].usage,
            heatingWattage: data[6].wattage,
            coolingUsagePerDay: data[7].usage,
            coolingWattage: data[7].wattage,
            personAvailableAtHomeIfWorkedFromOffice: wfhradio,
            companyId: companyId,
          }),
        });

        if (res.status === 200) {
          let responseJson;
          try {
            responseJson = await res.json();
          } catch {
            setLoading(false);
            setSubmitted(true);
            return;
          }
          if (responseJson.success === false) {
            setLoading(false);
            console.log(responseJson);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4><p style="font-size: 16px;">${responseJson.data}</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
          } else if (responseJson.status === 400) {
            setLoading(false);
            Swal.fire({
              icon: "error",
              html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
                  <p style="font-size: 16px;">${responseJson.title}</p>`,
              iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
            });
          } else {
            setLoading(false);
            localStorage.setItem(`ec_survey_submitted_${token}`, 'true');
            setSubmitted(true);
          }
        } else {
          setLoading(false);
          Swal.fire({
            icon: "error",
            html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
            <p style="font-size: 16px;">Error in creating site location</p>`,
            iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          });
        }
      }
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        html: `<h4 style="color:#CC2229; font-size: 20px; font-weight: bold;">Error!</h4>
        <p style="font-size: 16px;">Error in saving survey</p>`,
        iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
      });
    }

    setLoading(false);
  };

  const handleDaysChange = (e) => {
    const selectedDays = e.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      wfhDays: selectedDays,
    }));
    if (selectedDays !== "") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        wfhDays: "",
      }));
    }
    if (selectedDays === "0") {
      setIsDistanceDisabled(false);
      setIsDistanceRequired(false);
      setFormData((prev) => ({
        ...prev,
        primaryTransport: "",
        transportType: "",
        fuelUsed: "",
        fuelEfficiency: "",
        unit: "",
        distance: "",
      }));
    } else {
      setIsDistanceDisabled(false);
      setIsDistanceRequired(true);
    }
  };

  if (submitted) {
    return <SurveyThankYou />;
  }

  if (alreadySubmitted) {
    return (
      <div id="wrapper">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
            <div className="container-fluid">
              <a className="navbar-brand" href="#home">
                <img src="assets/img/logo.png" alt="Company Logo" height="30" className="d-inline-block align-top" />
              </a>
            </div>
          </nav>
        </header>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "calc(100vh - 56px)",
            background: "#fff",
          }}
        >
        <div
          style={{
            textAlign: "center",
            padding: "48px 40px",
            maxWidth: "480px",
            width: "100%",
            background: "#fff",
            borderRadius: "12px",
            border: "1px solid #f0e8e8",
            boxShadow: "0 2px 20px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: "#fde8e8",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#407775"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <polyline points="9 12 11 14 15 10" />
            </svg>
          </div>
          <span
            style={{
              display: "inline-block",
              background: "#fde8e8",
              color: "#c0392b",
              padding: "4px 16px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: 500,
              marginBottom: "16px",
            }}
          >
            Survey already submitted
          </span>
          <h2
            style={{
              color: "#c0392b",
              fontWeight: 700,
              fontSize: "22px",
              marginBottom: "12px",
            }}
          >
            Thank You for Your Response!
          </h2>
          <p
            style={{
              color: "#888",
              fontSize: "15px",
              lineHeight: "1.6",
              marginBottom: "20px",
            }}
          >
            It seems this survey has already been completed. We truly appreciate
            the time and effort you put into sharing your insights — your
            contribution means a lot to us.
          </p>
          <div
            style={{
              background: "#fde8e8",
              padding: "14px 16px",
              borderRadius: "8px",
              marginBottom: "28px",
              textAlign: "left",
            }}
          >
            <p style={{ color: "#c0392b", margin: 0, fontSize: "14px", lineHeight: "1.5" }}>
              If you think this is a mistake, please contact the person or team
              who shared the survey link with you.
            </p>
          </div>
          <p style={{ fontSize: "14px", color: "#888", marginTop: "16px" }}>
            Redirecting to{" "}
            <a href="https://ecoprism.com/" style={{ color: "#407775" }}>ecoprism.com</a>{" "}
            in {alreadySubmittedCountdown} second{alreadySubmittedCountdown !== 1 ? "s" : ""}...
          </p>
        </div>
        </div>
      </div>
    );
  }

  return (
    <div id="wrapper">
      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div id="">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
            <div className="container-fluid">
              <a className="navbar-brand" href="#home">
                <img src="assets/img/logo.png" alt="Company Logo" height="30" className="d-inline-block align-top" />
              </a>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0">
                  <li className="nav-item">
                    <a className="nav-link text-white" href="#profile">
                      <img class="icon mr-3" src="assets/img/User.png" alt="User" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
        {isInitializingSurvey ? (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "calc(100vh - 60px)", gap: "16px" }}>
            <CircularProgress style={{ color: "#407775" }} />
            <p style={{ fontSize: "16px", color: "#407775", fontWeight: 500, margin: 0 }}>Validating Survey Link...</p>
          </div>
        ) : (
        <div className="container survey-form p-4 p-lg-5">
          <div className="row mb-4">
            <div className="col">
              <div className="form-header">
                <h1 className="title" style={{ color: "407775!important" }}>
                  Employee Commute Survey
                </h1>
              </div>
            </div>
          </div>
          <div className="form-part">
            <form>
              <div className="row gx-5 gy-3">
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="surveyPeriod">
                      Survey Period
                    </label>
                    <input type="text" id="surveyPeriod" value={formData.surveyPeriod} class="form-control" placeholder="Auto-populated" disabled />
                  </div>
                </div>
              </div>
              <h2 className="my-3">
                <img className="mr-3" src="./assets/img/formsapps/emp-details.svg" alt="Preview of the survey form" />
                EMPLOYEE DETAILS
              </h2>
              <div className="row gx-5 gy-3">
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="employeeEmail">
                      Employee Email
                    </label>
                    <input type="email" id="employeeEmail" value={formData.employeeEmail} onChange={handleInputChange} class="form-control" placeholder="Auto-populated" disabled />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="employeeId">
                      Employee ID <span className="mark-form">*</span>
                    </label>
                    <input
                      type="text"
                      id="employeeId"
                      name="employeeId"
                      className={`form-control ${errors.employeeId ? "is-invalid" : ""}`}
                      value={formData.employeeId}
                      placeholder="Enter your Employee ID"
                      onChange={(e) => {
                        setFormData({ ...formData, employeeId: e.target.value });
                        setErrors((prevErrors) => ({ ...prevErrors, employeeId: "" }));
                      }}
                    />
                    {errors.employeeId && <div className="invalid-feedback">{errors.employeeId}</div>}
                  </div>
                </div>

                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="employeeName">
                      Name of employee
                    </label>
                    <input type="text" id="employeeName" value={formData.employeeName} onChange={handleInputChange} class="form-control" placeholder="Enter your name" />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="siteLocation">
                      Site Location <span className="mark-form">*</span>
                    </label>
                    <Dropdown
                      id="siteLocation"
                      name="siteLocation"
                      className={`form-control wd-100 ${errors.siteLocation ? "is-invalid" : ""}`}
                      value={formData.siteLocation}
                      options={siteLocations}
                      placeholder="Select Site Location"
                      required
                      invalid
                      onChange={(e) => {
                        const selectedSiteLocation = e.target.value;

                        const selectedLocation = siteLocations.find((location) => location.value === e.target.value);
                        console.log(e);
                        if (selectedLocation) {
                          setFormData({
                            ...formData,
                            siteLocation: selectedLocation.value,
                            state: selectedLocation.state, // Set the state based on the selected location
                            country: selectedLocation.country, // If needed, you can set the country too
                          });
                        }
                        console.log(formData);
                        setErrors((prevErrors) => ({ ...prevErrors, siteLocation: "" }));
                      }}
                    />
                    {errors.siteLocation && <div className="invalid-feedback">{errors.siteLocation}</div>}
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="state">
                      State <span className="mark-form">*</span>
                    </label>
                    <input type="text" id="state" value={formData.state} onChange={handleInputChange} required class="form-control" placeholder="Auto-populated" disabled />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="country">
                      Country <span className="mark-form">*</span>
                    </label>
                    <input type="text" id="country" value={formData.country} onChange={handleInputChange} required class="form-control" placeholder="Auto-populated" disabled />
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="workingDays">
                      No. of working days in a week <span className="mark-form">*</span>
                    </label>
                    <Dropdown
                      id="workingDays"
                      className={`form-control wd-100 ${errors.workingDays ? "is-invalid" : ""}`}
                      value={formData.workingDays}
                      options={workingDaysOptions}
                      onChange={(e) => {
                        const newWorkingDays = e.value;
                        const updatedWfhDays =
                          formData.wfhDays !== "" &&
                          formData.wfhDays !== null &&
                          parseInt(formData.wfhDays) > parseInt(newWorkingDays)
                            ? ""
                            : formData.wfhDays;
                        setFormData({ ...formData, workingDays: newWorkingDays, wfhDays: updatedWfhDays });
                        setErrors((prevErrors) => ({ ...prevErrors, workingDays: "", wfhDays: "" }));
                      }}
                      placeholder="Select No. of days"
                      required
                      invalid
                    />
                    {errors.workingDays && <div className="invalid-feedback">{errors.workingDays}</div>}
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="wfhDays">
                      Average work from office days each week <span className="mark-form">*</span>
                    </label>
                    <Dropdown id="numberOfDays" className={`form-control wd-100 ${errors.wfhDays ? "is-invalid" : ""}`} value={formData.wfhDays} options={wfhDaysOptions} onChange={handleDaysChange} placeholder="Select No. of days" />
                    {errors.wfhDays && <div className="invalid-feedback">{errors.wfhDays}</div>}
                  </div>
                </div>

                <div className="col-md-5">
                  <div className="form-group">
                    <label className="formlable" htmlFor="distance">
                      One way distance from home to office (km)
                      {isDistanceRequired && <span className="mark-form">*</span>}
                    </label>
                    <input
                      type="text"
                      id="distance"
                      name="distance"
                      className={`form-control ${errors.distance ? "is-invalid" : ""}`}
                      value={formData.distance}
                      placeholder="Enter the distance"
                      inputMode="decimal"
                      pattern="^\d*\.?\d*$"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*\.?\d*$/.test(value)) {
                          setFormData({ ...formData, distance: value });
                          setErrors((prevErrors) => ({ ...prevErrors, distance: "" }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      disabled={isDistanceDisabled} // Disable the field based on selection
                    />
                    {errors.distance && <div className="invalid-feedback">{errors.distance}</div>}
                  </div>
                </div>
              </div>
              {formData.wfhDays !== "0" && (
                <>
                  <h2 className="my-3">
                    <img className="mr-3" src="./assets/img/formsapps/transport.svg" alt="Preview of the survey form" />
                    MODE OF TRANSPORTATION
                  </h2>
                  <p style={{ color: "#494949" }}>You might use multiple modes of transport to commute to the office across the year. In this section, provide the details about the primary transportation mode you used for the majority of the year. In case you use multiple modes of transport in daily commute, provide the mode in which you cover majority of the distance.</p>
                  <div className="row gx-5 gy-3">
                    <div className="col-md-5">
                      <div className="form-group">
                        <label className="formlable" htmlFor="primaryTransport">
                          Primary mode of transport ({">"}= 80% of the time) <span className="mark-form">*</span>
                        </label>
                        <Dropdown
                          id="primaryTransport"
                          className={`form-control wd-100 ${errors.primaryTransport ? "is-invalid" : ""}`}
                          value={formData.primaryTransport}
                          options={transportOptions}
                          onChange={(e) => {
                            setFormData({ ...formData, primaryTransport: e.value });
                            setErrors((prevErrors) => ({ ...prevErrors, primaryTransport: "" }));
                          }}
                          placeholder="Select Primary mode of transport"
                          required
                        />
                        {errors.primaryTransport && (
                          <div className="invalid-feedback" style={{ display: "block" }}>
                            {errors.primaryTransport}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="form-group">
                        <label className="formlable" htmlFor="transportType">
                          Transport type
                        </label>
                        <input type="text" id="transportType" value={formData.transportType} onChange={handleInputChange} class="form-control" placeholder="Enter Transport type" />
                      </div>
                    </div>
                  </div>
                  <h2 className="my-3">
                    <img className="mr-3" src="./assets/img/formsapps/fuel.svg" alt="Preview of the survey form" />
                    FUEL CONSUMPTION
                  </h2>
                  <p style={{ color: "#494949" }}>Provide fuel consumption data if you are commuting in your own vehicle.</p>
                  <div className="row gx-5 gy-3">
                    <div className="col-md-5">
                      <div className="form-group">
                        <label className="formlable" htmlFor="fuelUsed">
                          Fuel used in vehicle
                        </label>
                        <Dropdown id="fuelUsed" className="form-control wd-100" value={formData.fuelUsed} options={fuelOptions} onChange={(e) => setFormData({ ...formData, fuelUsed: e.value })} placeholder="Select Fuel used in vehicle" />
                      </div>
                    </div>
                    {/* Only show this if fuelUsed is not "Electric" */}
                    <div className="col-md-5">
                      <div className="row gx-4 gy-3">
                        <div className="col-md-7">
                          <div className="form-group">
                            <label className="formlable" htmlFor="fuelEfficiency">
                              Fuel efficiency
                            </label>
                            <input
                              type="text"
                              id="fuelEfficiency"
                              value={formData.fuelEfficiency}
                              onChange={handleInputChange}
                              className="form-control"
                              placeholder="Enter Fuel efficiency"
                              inputMode="decimal"
                              pattern="[0-9.]*"
                              title="Numbers and decimal only"
                            />
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="form-group">
                            <label className="formlable" htmlFor="fuelUnit">
                              Unit
                            </label>
                            <Dropdown id="unit" className="form-control wd-100" value={formData.unit} options={unitOptions} onChange={(e) => setFormData({ ...formData, unit: e.value })} placeholder="Select Unit" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <h2 className="my-3">
                <img className="mr-3" src="./assets/img/formsapps/wfh.svg" alt="Preview of the survey form" />
                WORK FROM HOME
              </h2>
              <p>In this category, provide an estimated usage duration and wattage of different appliances while working from home which otherwise wouldn't have been used.</p>
              <div className="row">
                <div className="col-md-8">
                  <div className="data-responsive">
                    <DataTable value={data} rows={10} rowsPerPageOptions={[10, 20, 25, 50]} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" emptyMessage="No data found.">
                      <Column header="Equipment" field="equipment" />
                      <Column
                        header="Usage per day (hrs)"
                        field="usage"
                        body={(rowData, { rowIndex }) => (
                          <InputNumber value={rowData.usage} onValueChange={(e) => handleInputChangeDataTableUsage(e, rowData, rowIndex)} mode="decimal" minFractionDigits={0} maxFractionDigits={2} className="p-inputnumber" placeholder="Enter Value" />
                        )}
                      />
                      <Column
                        header="Wattage (W)"
                        field="wattage"
                        body={(rowData, { rowIndex }) => (
                          <InputNumber value={rowData.wattage} onValueChange={(e) => handleInputChangeDataTableWattage(e, rowData, rowIndex)} mode="decimal" minFractionDigits={0} maxFractionDigits={2} className="p-inputnumber" placeholder="Enter Value" />
                        )}
                      />

                      <Column
                        header=""
                        body={(rowData, { rowIndex }) => (
                          <a
                            href="#"
                            className="next-link"
                            style={{
                              fontSize: "14px", // Adjust the font size as needed
                              width: "200px", // Adjust the width as needed
                              color: "#407775", // Text color
                              textDecoration: "none", // Remove underline
                              display: "inline-block", // Ensure width is applied
                              padding: "10px", // Add padding if needed
                              textAlign: "center", // Center text
                            }}
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default anchor behavior
                              handleRowAction(rowData, rowIndex);
                            }}
                          >
                            Use average data
                          </a>
                        )}
                      />
                    </DataTable>
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col">
                  <label className="formlable" htmlFor="wfh">
                    Would a person be available at home even if you had worked from office?
                  </label>
                  <div className="flex flex-wrap gap-3">
                    <div className="flex align-items-center">
                      <RadioButton inputId="wfhYes" name="wfh" value="true" checked={formData.wfh === "true"} onChange={(e) => setFormData({ ...formData, wfh: e.value })} />
                      <label htmlFor="wfhYes" className="ml-2 mb-0">
                        Yes
                      </label>
                      <RadioButton inputId="wfhNo" name="wfh" value="false" checked={formData.wfh === "false"} onChange={(e) => setFormData({ ...formData, wfh: e.value })} className="ml-4" />
                      <label htmlFor="wfhNo" className="ml-2 mb-0">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            {validationMessage && (
              <div
                style={{
                  marginTop: "30px",
                  padding: "12px 15px",
                  backgroundColor: "#FFF3CD",
                  border: "1px solid #FFE69C",
                  borderRadius: "4px",
                  color: "#856404",
                  fontSize: "14px",
                  fontWeight: "500",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "10px",
                  maxWidth: "fit-content",
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3.05h16.94a2 2 0 0 0 1.71-3.05L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                  <line x1="12" y1="9" x2="12" y2="13"></line>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
                {validationMessage}
              </div>
            )}
            <div className="forms-buttons-container">
              <Button className="outline-btn" variant="contained" color="primary" onClick={() => navigate("/employee-commute-data")}>
                Close
              </Button>
              <Button className="next-button" variant="contained" color="primary" onClick={handleSave}>
                Share
              </Button>
            </div>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default ECSurveyForm;
